var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      ref: "layout",
      attrs: {
        errors: _vm.errors,
        noContainer: "",
        fluid: "",
        title: /*`Book a ${form.instrument.name} Lesson`*/ "Find a Lesson Time",
        breadcrumbs: _vm.breadcrumbs,
        guest: _vm.guest,
        child: _vm.child,
        review: _vm.review,
        hideNavOnScroll: _vm.$vuetify.breakpoint.xs,
        location: _vm.guest.location,
      },
      scopedSlots: _vm._u([
        {
          key: "toggleFilter",
          fn: function () {
            return [
              false
                ? _c(
                    "v-menu",
                    {
                      attrs: { "nudge-bottom": "36", left: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          rounded: "",
                                          outlined: "",
                                          color: "white",
                                          icon: _vm.$vuetify.breakpoint.xs,
                                          small: "",
                                        },
                                        model: {
                                          value: _vm.speedDial,
                                          callback: function ($$v) {
                                            _vm.speedDial = $$v
                                          },
                                          expression: "speedDial",
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$vuetify.breakpoint.smAndUp
                                          ? "Options"
                                          : ""
                                      )
                                    ),
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          right:
                                            _vm.$vuetify.breakpoint.smAndUp,
                                          color: "white",
                                        },
                                      },
                                      [_vm._v("tune")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2078875151
                      ),
                      model: {
                        value: _vm.speedDial,
                        callback: function ($$v) {
                          _vm.speedDial = $$v
                        },
                        expression: "speedDial",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "soli-round", attrs: { width: "250" } },
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-chip-group",
                                {
                                  staticClass: "justify-end",
                                  attrs: { column: "" },
                                  model: {
                                    value: _vm.selection,
                                    callback: function ($$v) {
                                      _vm.selection = $$v
                                    },
                                    expression: "selection",
                                  },
                                },
                                _vm._l(_vm.selects, function (chip) {
                                  return _c(
                                    "v-chip",
                                    {
                                      key: chip.name,
                                      class: [
                                        //'primary primary--text v-chip--outlined shadow-blue',
                                        "font-weight-bold v-chip--outlined mx-1",
                                      ],
                                      attrs: {
                                        value: chip.name,
                                        id: chip.name,
                                        outlined: "",
                                        dark: "",
                                        color: "dark",
                                        disabled: chip.disabled,
                                        ripple: false,
                                      },
                                      model: {
                                        value: chip.show,
                                        callback: function ($$v) {
                                          _vm.$set(chip, "show", $$v)
                                        },
                                        expression: "chip.show",
                                      },
                                    },
                                    [
                                      _vm._v(_vm._s(chip.display())),
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "ml-1",
                                          attrs: { small: "" },
                                        },
                                        [_vm._v("expand_more")]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-col",
        {
          staticClass: "pt-0 white--text text-center px-0 mx-auto",
          attrs: { cols: "12", sm: "11", md: "10", lg: "8" },
        },
        [
          false
            ? _c(
                "v-row",
                {
                  staticClass: "mb-3",
                  attrs: { "no-gutters": "", justify: "center" },
                },
                [
                  _c(
                    "v-chip-group",
                    {
                      attrs: { "content-class": "px-05", "center-active": "" },
                      model: {
                        value: _vm.selection,
                        callback: function ($$v) {
                          _vm.selection = $$v
                        },
                        expression: "selection",
                      },
                    },
                    _vm._l(_vm.selects, function (chip) {
                      return _c(
                        "v-chip",
                        {
                          key: chip.name,
                          class: [
                            //'primary primary--text v-chip--outlined shadow-blue',
                            "font-weight-bold v-chip--outlined mx-1",
                          ],
                          staticStyle: { border: "1px solid white" },
                          attrs: {
                            value: chip.name,
                            id: chip.name,
                            outlined: "",
                            dark: "",
                            disabled: chip.disabled,
                            ripple: false,
                          },
                          model: {
                            value: chip.show,
                            callback: function ($$v) {
                              _vm.$set(chip, "show", $$v)
                            },
                            expression: "chip.show",
                          },
                        },
                        [
                          _vm._v(_vm._s(chip.display())),
                          _c(
                            "v-icon",
                            { staticClass: "ml-1", attrs: { small: "" } },
                            [_vm._v("expand_more")]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card",
            {
              staticClass: "mx-auto",
              class: { "soli-round": _vm.$vuetify.breakpoint.smAndUp },
              attrs: { tile: _vm.$vuetify.breakpoint.xs },
            },
            [
              _c(
                "v-container",
                {
                  staticClass: "px-0",
                  class: { "pa-5": _vm.$vuetify.breakpoint.smAndUp },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "sticky-selects",
                      class: {
                        "sticky-padded": !_vm.$refs.layout?.appBarHidden,
                      },
                      attrs: { "no-gutters": "", justify: "center" },
                    },
                    [
                      !_vm.virtualClient
                        ? _c(
                            "v-chip-group",
                            {
                              attrs: { "center-active": "" },
                              model: {
                                value: _vm.selection,
                                callback: function ($$v) {
                                  _vm.selection = $$v
                                },
                                expression: "selection",
                              },
                            },
                            _vm._l(_vm.selects, function (chip, name, idx) {
                              return _c(
                                "v-chip",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !chip.hidden,
                                      expression: "!chip.hidden",
                                    },
                                  ],
                                  key: chip.name,
                                  class: [
                                    "font-weight-bold v-chip--outlined soli-grey",
                                    idx == 0 ? "ml-3" : "mx-1",
                                    idx == _vm.selects.length - 1
                                      ? "mr-3"
                                      : "mx-1",
                                  ],
                                  attrs: {
                                    value: chip.name,
                                    id: chip.name,
                                    disabled: chip.disabled,
                                    ripple: false,
                                  },
                                  model: {
                                    value: chip.show,
                                    callback: function ($$v) {
                                      _vm.$set(chip, "show", $$v)
                                    },
                                    expression: "chip.show",
                                  },
                                },
                                [
                                  _vm._v(_vm._s(chip.display())),
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "ml-1",
                                      attrs: { small: "" },
                                    },
                                    [_vm._v("expand_more")]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _c(
                            "v-chip-group",
                            {
                              attrs: { "center-active": "" },
                              model: {
                                value: _vm.virtualClientAlert,
                                callback: function ($$v) {
                                  _vm.virtualClientAlert = $$v
                                },
                                expression: "virtualClientAlert",
                              },
                            },
                            _vm._l(_vm.selects, function (chip, name, idx) {
                              return _c(
                                "v-chip",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !chip.hidden,
                                      expression: "!chip.hidden",
                                    },
                                  ],
                                  key: chip.name,
                                  class: [
                                    "font-weight-bold v-chip--outlined soli-grey",
                                    idx == 0 ? "ml-3" : "mx-1",
                                    idx == _vm.selects.length - 1
                                      ? "mr-3"
                                      : "mx-1",
                                  ],
                                  attrs: {
                                    value: chip.name,
                                    id: chip.name,
                                    disabled: chip.disabled,
                                    ripple: false,
                                  },
                                },
                                [
                                  _vm._v(_vm._s(chip.display())),
                                  !_vm.virtualClient
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "ml-1",
                                          attrs: { small: "" },
                                        },
                                        [_vm._v("expand_more")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("SoliDateScroll", {
                    ref: "date",
                    class: {
                      "grow-height": !!_vm.form.startDate,
                      "shrink-height": _vm.$vuetify.breakpoint.smAndUp,
                      "shrink-height-mobile": _vm.$vuetify.breakpoint.xs,
                    },
                    attrs: {
                      error: _vm.errors.starts_at,
                      future: true,
                      events: _vm.searchAssignments.map((e) =>
                        _vm.globalMomentYMD(e.starts_at)
                      ),
                      select: false,
                      intervalsLoading: _vm.apiLoading,
                      intervals: _vm.assignmentIntervals,
                      loading: _vm.assignmentsLoading,
                      selectedInstrument: _vm.form.instrument?.id,
                      selectedLocation: _vm.form.location,
                      floating: false,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.selectDate($event)
                      },
                      inputTime: function ($event) {
                        return _vm.selectTime($event)
                      },
                    },
                    model: {
                      value: _vm.form.startDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "startDate", $$v)
                      },
                      expression: "form.startDate",
                    },
                  }),
                  _vm._v(" "),
                  true
                    ? _c(
                        "v-container",
                        { staticClass: "justify-center flex" },
                        [
                          _c(
                            "v-card-subtitle",
                            {
                              staticClass: "soli-grey text-align-start",
                              staticStyle: { "max-width": "600px" },
                            },
                            [
                              _vm._v(
                                "*Lessons can be scheduled up to two weeks in the\n                        future. Please try and select a time that works for\n                        you on a weekly basis."
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.selection
            ? _c("SoliResponsiveDialog", {
                ref: "selection",
                attrs: { close: false },
                on: {
                  reset: function ($event) {
                    ;[
                      (_vm.selects[_vm.selection].show = false),
                      (_vm.selection = null),
                    ]
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "px-0",
                              class: { "py-3": _vm.$vuetify.breakpoint.xs },
                            },
                            [
                              _c(
                                _vm.selects[_vm.selection].comp,
                                _vm._b(
                                  {
                                    tag: "component",
                                    on: {
                                      input: function ($event) {
                                        return _vm.resetOptions()
                                      },
                                    },
                                    model: {
                                      value: _vm.form[_vm.selection],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, _vm.selection, $$v)
                                      },
                                      expression: "form[selection]",
                                    },
                                  },
                                  "component",
                                  { ..._vm.selects[_vm.selection].props() },
                                  false
                                )
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2054694486
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.alerts, function (alert) {
            return _c(
              "div",
              { key: alert?.subtitle },
              [
                alert
                  ? _c(
                      "SoliChoice",
                      {
                        attrs: {
                          title: alert.title,
                          subtitle: alert.subtitle,
                          button1: alert.button1,
                          button2: alert.button2,
                          warning: alert.warning,
                          permanent: alert.permanent,
                        },
                        on: {
                          option1: function ($event) {
                            return alert.option1()
                          },
                          option2: function ($event) {
                            return alert.option2()
                          },
                        },
                      },
                      [
                        [
                          !_vm.futureBookingConflict?.date
                            ? _c(
                                "v-list",
                                { attrs: { dense: "" } },
                                _vm._l(
                                  _vm.futureBookingConflict,
                                  function (conflict) {
                                    return _c(
                                      "v-list-item",
                                      { key: conflict.starts_at },
                                      [
                                        _c(
                                          "small",
                                          { staticClass: "soli-grey" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                `· ${
                                                  conflict.type
                                                } on ${_vm.globalMomentDate(
                                                  conflict.starts_at
                                                )}`
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                        ],
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      false
        ? _c(
            "v-bottom-sheet",
            {
              on: {
                "click:outside": function ($event) {
                  _vm.showSubmit = false
                },
              },
              model: {
                value: _vm.showSubmit,
                callback: function ($$v) {
                  _vm.showSubmit = $$v
                },
                expression: "showSubmit",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "half-round" },
                [
                  _c(
                    "v-container",
                    { staticStyle: { "max-width": "600px" } },
                    [
                      _c("Lesson", {
                        attrs: {
                          lesson: {
                            ..._vm.form,
                            starts_at: _vm.$_data_lessonStart,
                          },
                          errors: _vm.errors,
                          hideMakeAChange: "",
                          wide: "",
                          size: "64",
                          guest: _vm.guest,
                        },
                      }),
                      _vm._v(" "),
                      _c("SoliBtn", {
                        staticStyle: { color: "white !important" },
                        attrs: {
                          block: "",
                          text: "Continue to Checkout",
                          gradient: "gradient-orange",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.virtualClientAlert
        ? _c("SoliChoice", {
            attrs: {
              title: "Online Lessons for Busy Adults",
              subtitle:
                "This program is only available with the selected options at this time. If you'd like to explore other options, please contact us.",
              button1: "Close",
              button2: "Contact Us",
            },
            on: {
              option1: function ($event) {
                _vm.closeModal(() => (_vm.virtualClientAlert = false))
              },
              option2: function ($event) {
                _vm.closeModal(() => {
                  _vm.virtualClientAlert = false
                  _vm.$refs.layout.showContact()
                })
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.virtualClientAlert = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }